const Colors = {
  Elmt: {
    White: 0xffffff,
    Beige: 0xf2f0e2,
    Red: 0xe07164,
    Green: 0x51a267,
    Orange: 0xe77940,
    DarkBlue: 0x1d1e3d,
    Blue: 0x1E22AA,
    BleuNovotel: 0x1e22aa,
    Gray: 0x282c2d,
    Black: 0x000000,
  },
  Text: {
    White: "#ffffff",
    Beige: "#F2F0E2",
    Red: "#e07164",
    Green: "#51a267",
    Orange: "#e77940",
    DarkBlue: "#1D1E3D",
    Blue: "#1E22AA",
    BleuNovotel: "#1E22AA",
    Gray: "#282c2d",
    Black: "#000000",
  },
};

export { Colors };
